import React, { FC } from "react";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import { HOST_PRICING_PLANS } from '../constants';
import PremiumOnlyImage from "components/LocationCreationImages/PremiumOnlyImage";

export interface Plan {
  id: number;
  name: string;
  price: string;
  features: string[];
}

interface HostingPlanSelectorProps {
  selectedPlanId: number;
  onSelectPlan: (id: number) => void;
}

const HostingPlanSelector: FC<HostingPlanSelectorProps> = ({
  selectedPlanId,
  onSelectPlan,
}) => (
  <MDBox>
    {/* Header */}
    <MDTypography variant="h6" fontWeight="medium">
      Choose Your Hosting Plan
    </MDTypography>
    <MDTypography variant="caption" color="text" fontWeight="regular"sx={{
                lineHeight: '1.3',        // controls spacing between wrapped lines
                display: 'block',         // ensures proper wrapping
                whiteSpace: 'normal',     // prevents forced extra spacing
            }}>
      Select the hosting option that best matches how you want customers to find your restroom.
    </MDTypography>

    {/* Plan list */}
    <MDBox display="flex" flexDirection="column" gap={2} mt={2}>
      {HOST_PRICING_PLANS.map((plan) => {
        const isSelected = selectedPlanId === plan.id;

        return (
          <MDBox
            key={plan.id}
            onClick={() => onSelectPlan(plan.id)}
            sx={{
              cursor: "pointer",
              p: 2,
              borderRadius: "lg",
              border: isSelected
                ? "2px solid #21b2a6"
                : "1px solid rgba(0,0,0,0.15)",
              backgroundColor: isSelected
                ? "rgba(33,178,166,0.08)"
                : "transparent",
              transition: "all 0.2s ease-in-out",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Left Side */}
            <MDBox flex={1}>
              <MDTypography variant="h6" fontWeight="medium" color="text">
                {plan.name}
              </MDTypography>

              <MDTypography variant="button" color="info" fontWeight="bold">
                {plan.price}
              </MDTypography>

              <MDBox mt={1}>
                {plan.features.map((feature, i) => (
                  <MDTypography
                    key={i}
                    variant="caption"
                    color="text"
                    display="block"
                  >
                    • {feature}
                  </MDTypography>
                ))}
              </MDBox>
            </MDBox>

            {/* Right Side — Premium Icon */}
            <MDBox ml={2}>
              {plan.id === 2 && (
                <PremiumOnlyImage
                  resizeMode="contain"
                  style={{
                    position: "relative",
                    top: 0,
                    right: 0,
                    width: "100%",
                    height: 120,
                  }}
                />
              )}
            </MDBox>
          </MDBox>
        );
      })}
    </MDBox>
  </MDBox>
);

export default HostingPlanSelector;
